export const defaultExternalPlugins = {
  fullscreen: "/tinymce/js/tinymce/plugins/fullscreen/plugin.min.js",
  lists: "/tinymce/js/tinymce/plugins/lists/plugin.min.js",
  link: "/tinymce/js/tinymce/plugins/link/plugin.min.js",
  wordcount: "/tinymce/js/tinymce/plugins/wordcount/plugin.min.js",
  advlist: "/tinymce/js/tinymce/plugins/advlist/plugin.min.js",
  table: "/tinymce/js/tinymce/plugins/table/plugin.min.js",
  image: "/tinymce/js/tinymce/plugins/image/plugin.min.js",
  pagebreak: "/tinymce/js/tinymce/plugins/pagebreak/plugin.min.js",
  media: "/tinymce/js/tinymce/plugins/media/plugin.min.js",
  nonbreaking: "/tinymce/js/tinymce/plugins/nonbreaking/plugin.min.js"
};

export const defaultPlugins = [
  "fullscreen",
  "lists",
  "link",
  "wordcount",
  "advlist",
  "table",
  "image",
  "pagebreak",
  "media",
  "nonbreaking"
];

export const defaultMenu = {
  file: { title: "File", items: "newdocument" },
  edit: { title: "Edit", items: "undo redo | cut copy paste pastetext | selectall" },
  view: { title: "View", items: "visualaid" },
  insert: { title: "Insert", items: "image link media table" },
  format: {
    title: "Format",
    items: "bold italic underline strikethrough superscript subscript | formats | removeformat"
  }
};

export const defaultToolbar =
  "undo redo | styles | bold italic underline strikethrough | pastetext | " +
  "alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | " +
  "link image media | table | fullscreen";

export const defaultOptions = {
  visual: false,
  branding: false,
  height: 240
};

export const fullToolbar = [
  "undo redo | styleselect | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent | blockquote | subscript superscript | removeformat | code",
  "fontsizeselect | forecolor backcolor | link unlink | image media | hr | charmap | searchreplace | table | fullscreen"
];

export const domMenu = {
  file: { title: "File", items: "newdocument" },
  edit: { title: "Edit", items: "undo redo | cut copy paste pastetext | selectall" },
  view: { title: "View", items: "visualaid" },
  insert: { title: "Insert", items: "image link media table" },
  format: {
    title: "Format",
    items:
      "bold italic underline strikethrough superscript subscript codeformat | styles blocks fontsize align lineheight | forecolor backcolor | language | removeformat"
  }
};
export const tinymceScriptSrc = "/tinymce/js/tinymce/tinymce.min.js?v=1.0.0";

export const defaultSkinUrl = "/tinymce/js/tinymce/skins/ui/oxide";

export const defaultContentCss = "/tinymce/js/tinymce/skins/content/default/content.min.css";
